__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2025-10-29-1761748243-stable-dev/";